"use client";

import { mainnet } from "wagmi/chains";
import type { Chain } from "wagmi/chains";
import { Environment } from "@getpara/react-sdk";
import { cookieStorage, createConfig, createStorage, http, fallback } from "wagmi";

export const ENVIRONMENT =
  process.env.NODE_ENV === "development" ? Environment.DEV : Environment.PROD;
export const API_KEY = process.env.NEXT_PUBLIC_PARA_API_KEY!;
export const WALLET_CONNECT_PROJECT_ID =
  process.env.NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID!;

// Paxos SDK Configuration
export const PAXOS_SDK_CONFIG = {
  // Environment-specific settings
  ENVIRONMENT:
    process.env.NODE_ENV === "development" ? "staging" : "production", // Use staging for dev, production for prod

  // Vault configurations for campUSD
  VAULT_KEYS: {
    CAMPUSD: "campUSD", // String format
    CAMPUSD_ENUM: "CAMPUSD", // VaultKeys enum format
  },

  // Supported chain IDs for Paxos operations
  SUPPORTED_CHAINS: {
    ETHEREUM: 1, // Ethereum Mainnet
    CAMP: 484, // Camp Network
  },

  // Token configurations
  TOKENS: {
    SOURCE: "USDC", // Token symbol on source chain (Ethereum)
    DESTINATION: "CampUSD", // Token symbol on destination chain (Camp)
  },
} as const;

if (!API_KEY || API_KEY === "") {
  throw new Error(
    "API key is not defined. Please set NEXT_PUBLIC_PARA_API_KEY in your environment variables.",
  );
}

if (!WALLET_CONNECT_PROJECT_ID || WALLET_CONNECT_PROJECT_ID === "") {
  throw new Error(
    "Wallet Connect project ID is not defined. Please set NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID in your environment variables.",
  );
}

// Define Camp Network chains
export const campNetwork: Chain & { iconUrl?: string } = {
  id: 484,
  name: "Camp Network",
  nativeCurrency: { name: "CAMP", symbol: "CAMP", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://rpc-mainnet.campnetwork.xyz"] },
  },
  blockExplorers: {
    default: {
      name: "Camp Explorer",
      url: "https://camp.cloud.blockscout.com",
    },
  },
  iconUrl: "/camp-token.svg",
};

// Define supported chains
export const supportedChains = [
  campNetwork, // Camp Network (first - mainnet)
  mainnet, // Ethereum Mainnet
] as const;

export const config = {
  chains: [campNetwork, mainnet],
  transports: {
    [campNetwork.id]: http("https://rpc-mainnet.campnetwork.xyz"), // Camp Network
    [mainnet.id]: fallback([
      http("https://eth.llamarpc.com"), // LlamaRPC - Primary
      http("https://eth.drpc.org"), // dRPC - Secondary  
      http("https://cosmopolitan-omniscient-water.quiknode.pro/56b91373a1b03dfa78a324af18693a9a08fe60c2/"), // QuickNode - Tertiary
    ]), // Ethereum Mainnet - Fallback RPC
  },
  storage: createStorage({
    storage: cookieStorage,
  }),
  ssr: true,
} as const;

export const wagmiConfig = createConfig(config);
